import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { useLocation } from "react-router-dom";

interface SearchProps {
  onSearch: (query: string) => void;
}

const Searchbox: React.FC<SearchProps> = ({ onSearch }) => {
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState<string>("");

  useEffect(() => {
    if (location.state?.search) {
      setSearchTerm(location.state.search);
    }
  }, [location.state]);

  useEffect(() => {
    const delay = 600;

    const debounceSearch = setTimeout(() => {
      onSearch(searchTerm);
    }, delay);

    return () => clearTimeout(debounceSearch);
  }, [searchTerm]);

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchTerm(event.target.value || "");
  };

  return (
    <div className="ct-search">
      <FiSearch className="ct-search-icon" />

      <input
        type="text"
        value={searchTerm}
        placeholder="Search something..."
        autoComplete="off"
        onChange={handleInputChange}
        className="ct-search-input"
      />

      <style>{`
        .ct-search {
          display: flex;
          align-items: center;
          gap: 8px;
          background: #f8fafc;
          border: 1.5px solid #e2e8f0;
          border-radius: 10px;
          padding: 7px 12px;
          min-width: 220px;
          transition: all 0.15s ease;
        }

        .ct-search:hover {
          border-color: #cbd5e1;
        }

        .ct-search:focus-within {
          border-color: #2563eb;
          background: #ffffff;
          box-shadow: 0 0 0 3px rgba(37,99,235,0.08);
        }

        .ct-search-icon {
          font-size: 15px;
          color: #94a3b8;
        }

        .ct-search-input {
          border: none;
          outline: none;
          background: transparent;
          font-size: 13px;
          font-weight: 500;
          color: #0f172a;
          width: 100%;
        }

        .ct-search-input::placeholder {
          color: #94a3b8;
        }

        @media (max-width: 700px) {
          .ct-search {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default Searchbox;